import Paragraph from '@editorjs/paragraph';

import { PARAGRAPH_SANITIZE } from '../sanitize-config';

// Body paragraph tool: extends EditorJS Paragraph with a save-sanitization
// allowlist aligned to the app's canonical HTML vocabulary (strong/em, ref
// chips, color spans). Keeps the default paste handler for <P> tags.
export class ParagraphTool extends Paragraph {
  static get sanitize() {
    return PARAGRAPH_SANITIZE;
  }

  // Enter inserts a line break within the block instead of splitting into a
  // new block — new blocks are only created via the Add-block menu.
  static get enableLineBreaks(): boolean {
    return true;
  }
}
